(function () {
  'use strict';

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList);
  }

  function normalize(value) {
    var text = (value || '').toLowerCase().trim();
    if (text.normalize) {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return text;
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function init(root) {
    if (root.dataset.rzBrandsReady === 'true') return;
    root.dataset.rzBrandsReady = 'true';

    var indexLinks = toArray(root.querySelectorAll('[data-rz-index-link]'));
    var status = root.querySelector('[data-rz-brands-status]');
    var emptyMessage = root.querySelector('[data-rz-brands-empty]');
    var input = root.querySelector('[data-rz-brands-search]');

    var groups = toArray(root.querySelectorAll('[data-rz-group]')).map(function (group) {
      return {
        element: group,
        letter: group.getAttribute('data-rz-group'),
        items: toArray(group.querySelectorAll('[data-rz-brand]')).map(function (item) {
          return { element: item, search: normalize(item.getAttribute('data-rz-brand')) };
        })
      };
    });

    indexLinks.forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = document.getElementById(link.getAttribute('href').slice(1));
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({
          behavior: prefersReducedMotion() ? 'auto' : 'smooth',
          block: 'start'
        });
        // Keep the anchor in the URL so the position can be shared and restored.
        if (window.history && window.history.replaceState) {
          window.history.replaceState(null, '', link.getAttribute('href'));
        }
      });
    });

    if (!input) return;

    function filter() {
      var query = normalize(input.value);
      var activeLetters = {};
      var visibleCount = 0;

      groups.forEach(function (group) {
        var shown = 0;

        group.items.forEach(function (item) {
          var matches = query === '' || item.search.indexOf(query) !== -1;
          item.element.hidden = !matches;
          if (matches) shown += 1;
        });

        group.element.hidden = shown === 0;
        if (shown > 0) activeLetters[group.letter] = true;
        visibleCount += shown;
      });

      indexLinks.forEach(function (link) {
        link.classList.toggle('is-disabled', !activeLetters[link.getAttribute('data-rz-index-link')]);
      });

      if (emptyMessage) emptyMessage.hidden = visibleCount !== 0;
      if (status) {
        status.textContent = visibleCount + ' ' + (root.getAttribute('data-rz-results-label') || '');
      }
    }

    var timer;
    input.addEventListener('input', function () {
      clearTimeout(timer);
      timer = setTimeout(filter, 120);
    });
    input.addEventListener('search', filter);
  }

  function initAll(scope) {
    toArray((scope || document).querySelectorAll('[data-rz-brands]')).forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
